<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline ">
        <el-form-item label="业务系统" prop="sysId">
          <el-select
            v-model="form.sysId"
            placeholder="请选择业务系统"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in sysData"
              :key="index"
              :label="item.systemName"
              :value="item.systemId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" prop="proName">
          <el-input style="width: 217px;" clearable v-model="form.proName" placeholder="请输入产品类型名称"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="修改时间" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <!-- <el-table-column
          label="序号"
          type="index"
          >
        </el-table-column> -->
        <el-table-column
          label="业务系统"
          :show-overflow-tooltip="tooltip"
          width="220">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品名称"
          :show-overflow-tooltip="tooltip"
          width="220">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.abilityZhName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品描述"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.abilityDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="告警超时时间(ms)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.alarmTimeout }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品超时时间(ms)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.serviceTimeout }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否告警"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.needAlarm === 'true' ? '是': '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否禁用"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.turnOff === 'true'? '是': '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="修改时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.modifyTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="修改人"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.modifier }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          fixed="right"
          width="90">
          <template slot-scope="scope">
            <el-button size="mini" @click="detail(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog :title="historyTitle"  width="860px" center :modal-append-to-body='false' :visible.sync="historyDialog">
      <el-form :inline="true" :model="historyForm" class="demo-form-inline ">
        <el-form-item label="通道组名称:" >
          <span>{{historyForm.tableTitle}}</span>
        </el-form-item>
      </el-form>
      <el-table
        :data="historyData"
        style="width: 100%">
        <el-table-column
          label="通道名称"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.pipeName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="连接超时时间(ms)"
          width="140px">
          <template slot-scope="scope">
            <span >{{ scope.row.conTimeout }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="读超时间(ms)"
          width="120px">
          <template slot-scope="scope">
            <span >{{ scope.row.soTimeout }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="120px">
          <template slot-scope="scope">
            <span >{{ scope.row.active === 1 ? '启用': '停用' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
</style>
<script>
export default {
  name: 'abilityModiHistory',
  data () {
    return {
      form: {
        proName: '',
        sysId: '',
        date: ''
      },
      tooltip: true,
      required: true,
      historyDialog: false,
      editable: false,
      modalClick: false,
      historyTitle: '',
      historyForm: {
        tableTitle: ''
      },
      tableData: [],
      historyData: [],
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.page = 10
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form = {
        proName: '',
        date: ''
      }
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    detail (index, row) { // 详情
      if (row.pipeInfo) {
        this.historyData = row.pipeInfo.pipes
        this.historyForm.tableTitle = row.pipeInfo.groupName
      } else {
        this.historyData = []
        this.historyForm.tableTitle = ''
      }
      this.historyTitle = row.abilityZhName + '通道关联详情'
      this.historyDialog = true
    },
    initData () {
      this.$store.dispatch('getSystem') // 请求业务系统
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.sysIds = sysIds
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.abilityName = this.form.proName
      op.startTime = this.form.date ? this.form.date[0] : null
      op.endTime = this.form.date ? this.form.date[1] : null
      this.$axios({
        url: _this.$API.product.getAbilityModHistory,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/proManage/viewingHistory.vue